import { Link } from 'react-router';

import { Button } from '@/components/ui/button';

import {
  AuthTemplate,
  FooterLinks,
} from '@/pages/unauthenticated/auth/components';

export const ExpiredResetToken = ({ heading }: { heading: string }) => {
  return (
    <AuthTemplate
      heading={heading}
      subheading={<ExpiredTokenSubheading />}
      footer={<FooterLinks />}
    >
      <Button className="w-full" asChild>
        <Link to="/reset-password">Forgot Password?</Link>
      </Button>
    </AuthTemplate>
  );
};

function ExpiredTokenSubheading() {
  return (
    <span>
      Uh oh, this link has <span className="font-semibold">expired</span>.
      Please click the link below to restart the process.
    </span>
  );
}
